module.exports = __webpack_public_path__ + "img/animals_elephant.d2e16a42.png";